import React from 'react';
import PageHeader from '../../../../components/PageHeader';
import FilterDropDown from '../../../../components/FilterDropDown';
import Datatable from '../../../../components/DataTable';
import { Box, Button, IconButton, Stack, TablePagination, Typography } from '@mui/material';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { CancelToken } from 'apisauce';
import { useEffect } from 'react';
import appapi from '../../../../api/apiClient';
import { buttonStyle2 } from '../../../../utils/commonStyle';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import { useTranslation } from 'react-i18next';

export default function AddTraderList({ handleClose }) {
  const theme = useTheme();

  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { i18n: {language} } = useTranslation();

  const { companyDetails } = useSelector((state) => state.auth);
  const [selectedTraderIds, setSelectedTraderIds] = useState([]);

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
  });

  const [tradersList, setTradersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let source = CancelToken.source();

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '8%',
    },
    {
      id: 1,
      header: 'Trader',
      accessor: 'displayName',
      width: '77%',
    },
    {
      id: 3,
      header: 'Status',
      accessor: 'status',
      width: '25%',
      jcc: true,
      Cell: (item) => (
        <div className="flex !justify-center ">
          <Button
            sx={[
              {
                height: '28px',
                width: language === 'en' ?  '80px' : '100px',
                borderRadius: '16px',
                fontSize: '12px',
                fontWeight: 500,
                color: theme.palette.background.main,
                backgroundColor: theme.palette.primary.main,
                textTransform: 'capitalize',
                '&:hover': {
                  backgroundColor: theme.palette.background.main,
                  color: theme.palette.background.main,
                },
                '&:disabled': {
                  color: 'rgba(255,255,255,0.5)',
                  backgroundColor: theme.palette.primary.main,
                },
              },
            ]}
            onClick={() => requestTrader(item._id)}
            variant="contained"
          >
            {t('request')}
          </Button>
        </div>
      ),
    },
  ];

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    const companies = [...selectedTraderIds];
    const ids = companies.map((res) => res._id);
    if (checkedStatus) {
      companies.push(item);
    } else {
      const index = ids.indexOf(item._id);
      if (index != -1) {
        companies.splice(index, 1);
      }
    }
    setSelectedTraderIds([...companies]);
  };

  useEffect(() => {
    if (selectedTraderIds.length > 0) {
      const items = tradersList.map((res) => {
        return {
          ...res,
          isSelected: selectedTraderIds.map((res) => res._id).includes(res._id),
        };
      });
     
      setTradersList(items);
    } else {
      const items = tradersList.map((res) => {
        return {
          ...res,
          isSelected: false,
        };
      });
      
      setTradersList(items);
    }
  }, [selectedTraderIds]);

  const requestTrader = async (traderId) => {
    dispatch(setLoading(true));
    const response = await appapi.post(
      `/company-management/requestTrader`,
      {},
      {
        params: {
          companyId: companyDetails._id,
          traderId,
        },
      },
    );
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        setPayload((prev) => ({ ...prev, paginationPage: 1, page: 1, filter: payload.filter }));
        handleGetTrader();
        showmessage(data.message, 'success');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const requestMultipleTrader = async () => {
    dispatch(setLoading(true));
    const response = await appapi.post(
      `/company-management/requestMultipleTrader`,
      {},
      {
        params: {
          companyId: companyDetails._id,
          traderId: selectedTraderIds.map((res) => {
            return res._id;
          }),
        },
      },
    );
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        setPayload((prev) => ({ ...prev, paginationPage: 1, page: 1, filter: payload.filter }));
        handleGetTrader();
        showmessage(data.message, 'success');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetTrader = async () => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/company-management/allTraders/${companyDetails._id}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        field: payload.field,
        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setTradersList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setTradersList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0, }));
        setIsLoading(false);
      }
    } else {
      setTradersList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1, }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetTrader();
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder]);
  return (
    <Stack
      flex={1}
      style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderColor: '#8993AC26', borderWidth: '1px', minHeight: '70vh' }}
    >
      <Stack style={{ width: '100%' }}>
        <PageHeader
          tableType={'2'}
          headerColor={'#003399'}
          showCloseBtn={true}
          handleClose={handleClose}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
        >
          <Stack direction="row">
            <Stack style={{ paddingLeft: '10px' }}>
              <Typography
                className="fs-16 ff-Roboto fw-regular !capitalize"
                color={'#FFFFFF'}
              
              >
                {t('Add trader')}
              </Typography>
              <Typography
                className="fs-12 ff-Roboto fw-regular"
                color={'#FFFFFF99'}
              >
                {t('Select traders and request to KYC verification')}
              </Typography>
            </Stack>
            <Stack flexGrow={1} />
            <Button
              onClick={() => { requestMultipleTrader() }}
              className=""
              disabled={selectedTraderIds.length <= 0}
            >
              {/* <PersonAddIcon style={{ transform: 'scale(1.143)', color: theme.palette.primary.main, width: '12px', height: '12px' }} /> */}
              <Typography
                color={'#FFFFFF'}
                className="fs-14 ff-Roboto fw-medium !uppercase"
              >
                {t('request')}
              </Typography>
            </Button>
          </Stack>
        </PageHeader>
        <Stack flex={1}>
          <div className="relative pl-[16px]  bg-[#F2F3F580] h-[100%] inputFormStyle overflow-auto">
            <Stack className="">
              <Datatable
                themeType={2}
                columns={columns}
                data={tradersList}
                isLoading={isLoading}
                tableBodyBgColor={'#F2F3F580'}
                tableHeadBgColor={'#F2F3F580'}
                showCheckBox={true}
                onChangeCheckBox={handleOnChangeCheckBox}
              />
            </Stack>
            {payload.totalLength > 10 && <Stack
              style={{ backgroundColor: '#8993AC26', height: '1px', marginBottom: '10px', marginTop: '10px', opacity: 0.7 }}
              className="mx-[15px]"
            />}
            {payload.totalLength > 10 && (
              <Box className="flex justify-end items-center h-[56px] w-[98%] p-[5px] bg-[#F2F3F580]   mr-[10px] rounded-b-lg">
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[]}
                  count={payload.totalLength ? payload.totalLength : 0}
                  rowsPerPage={payload.limit ? payload.limit : 10}
                  page={payload.paginationPage ? payload.paginationPage : 0}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </Box>
            )}
          </div>
        </Stack>
      </Stack>
    </Stack>
  );
}
